import React from 'react';
import { Link } from 'react-router-dom';

import StandardPageTemplate from '../../templates/StandardPage';

const BulkUploadIndexPage = (): JSX.Element => {
  return (
    <StandardPageTemplate>
      <h1 className="f-serif f-normal">
        Generate Reports from a CSV
      </h1>
      <Link className="button mr-4 td-none" to="upload">Upload CSV</Link>
      <Link className="f-medium" to="campaigns">View Past Uploads</Link>
    </StandardPageTemplate>
  );
};

export default BulkUploadIndexPage;
